import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type BackupJob } from '../../api/resilience';

export function RestoreWizardPage() {
  const [backups, setBackups] = useState<BackupJob[]>([]);
  const [selected, setSelected] = useState('');
  const [region, setRegion] = useState('ap-southeast-1');
  const [result, setResult] = useState<string | null>(null);
  useEffect(() => { void resilienceApi.listBackups().then(setBackups); }, []);
  const restore = async () => {
    if (!selected) return;
    const r = await resilienceApi.restoreBackup(selected, { target_region: region });
    setResult(`Restore ${r.status} to ${r.target_region}`);
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Restore Wizard</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-6 rounded-xl border p-4 dark:border-slate-700 space-y-3">
        <select value={selected} onChange={(e) => setSelected(e.target.value)} className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800">
          <option value="">Select backup…</option>
          {backups.map((b) => <option key={b.id} value={b.id}>{b.resource_type} — {b.mode} ({b.status})</option>)}
        </select>
        <input value={region} onChange={(e) => setRegion(e.target.value)} placeholder="Target region" className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
        <button type="button" onClick={restore} className="rounded bg-emerald-600 px-4 py-2 text-sm text-white hover:bg-emerald-700">One-Click Restore</button>
        {result && <p className="text-sm text-emerald-700 dark:text-emerald-400">{result}</p>}
      </div>
    </div>
  );
}
